export default "__VITE_ASSET__DwcTai3S__"